/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WaterLevelRouteImport } from './routes/water-level'
import { Route as TemporaryRouteImport } from './routes/temporary'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as LoginRouteImport } from './routes/login'
import { Route as CompareMapRouteImport } from './routes/compare-map'
import { Route as IndexRouteImport } from './routes/index'

const WaterLevelRoute = WaterLevelRouteImport.update({
  id: '/water-level',
  path: '/water-level',
  getParentRoute: () => rootRouteImport,
} as any)
const TemporaryRoute = TemporaryRouteImport.update({
  id: '/temporary',
  path: '/temporary',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const CompareMapRoute = CompareMapRouteImport.update({
  id: '/compare-map',
  path: '/compare-map',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/compare-map': typeof CompareMapRoute
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/temporary': typeof TemporaryRoute
  '/water-level': typeof WaterLevelRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/compare-map': typeof CompareMapRoute
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/temporary': typeof TemporaryRoute
  '/water-level': typeof WaterLevelRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/compare-map': typeof CompareMapRoute
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/temporary': typeof TemporaryRoute
  '/water-level': typeof WaterLevelRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/compare-map'
    | '/login'
    | '/signup'
    | '/temporary'
    | '/water-level'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/compare-map'
    | '/login'
    | '/signup'
    | '/temporary'
    | '/water-level'
  id:
    | '__root__'
    | '/'
    | '/compare-map'
    | '/login'
    | '/signup'
    | '/temporary'
    | '/water-level'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CompareMapRoute: typeof CompareMapRoute
  LoginRoute: typeof LoginRoute
  SignupRoute: typeof SignupRoute
  TemporaryRoute: typeof TemporaryRoute
  WaterLevelRoute: typeof WaterLevelRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/water-level': {
      id: '/water-level'
      path: '/water-level'
      fullPath: '/water-level'
      preLoaderRoute: typeof WaterLevelRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/temporary': {
      id: '/temporary'
      path: '/temporary'
      fullPath: '/temporary'
      preLoaderRoute: typeof TemporaryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/compare-map': {
      id: '/compare-map'
      path: '/compare-map'
      fullPath: '/compare-map'
      preLoaderRoute: typeof CompareMapRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CompareMapRoute: CompareMapRoute,
  LoginRoute: LoginRoute,
  SignupRoute: SignupRoute,
  TemporaryRoute: TemporaryRoute,
  WaterLevelRoute: WaterLevelRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
